function pad2(n) {
  return String(n).padStart(2, '0')
}

function formatExportDate(d) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
}

export function exportFilteredAlertClients(clients) {
  const headers = [
    'Client Name',
    'Email',
    'Office',
    'State',
    'Election',
    'Date Added',
    'Account Executive',
    'Year',
    'Delta Alerts',
    'AdMo Alerts',
    'AdMo+ Alerts',
    'CTV Alerts',
    'Dashboards',
    'Digital Dashboards',
  ]

  const rows = clients.map(c => [
    c.client_name || '',
    c.email || '',
    c.office || '',
    c.state || '',
    c.election || '',
    c.date_added || '',
    c.account_executive || '',
    c.year || '',
    c.delta_alerts ? 'Y' : 'N',
    c.admo_alerts ? 'Y' : 'N',
    c.admo_plus_alerts ? 'Y' : 'N',
    c.ctv_alerts ? 'Y' : 'N',
    c.dashboards ? 'Y' : 'N',
    c.digital_dashboards ? 'Y' : 'N',
  ])

  const escape = (val) => {
    const str = String(val)
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
      return `"${str.replace(/"/g, '""')}"`
    }
    return str
  }

  const csv = [headers.map(escape).join(','), ...rows.map(row => row.map(escape).join(','))].join('\n')

  const dateStr = formatExportDate(new Date())
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `alert-tracker-export-${dateStr}.csv`
  link.click()
  URL.revokeObjectURL(url)
}
